import type { FC } from "react";

import { Txt } from "@ui/components/Txt";

import { useConfig } from "@jti/app-context/useConfig";
import type { Address } from "@jti/fe-common";

type AddressStreetInfoProps = {
  address: Address;
};

export const AddressStreetInfoTaiwan: FC<AddressStreetInfoProps> = ({ address }) => {
  const { COUNTRY_NAME } = useConfig();

  const { streetName, streetAdditional, postcode, city, district } = address;

  const firstRow = [postcode, city, district].filter(Boolean).join(", ");
  const secondRow = [streetName, streetAdditional, COUNTRY_NAME].filter(Boolean).join(", ");
  return (
    <>
      <Txt>{firstRow}</Txt>
      <Txt>{secondRow}</Txt>
    </>
  );
};
